import { NgModule, ErrorHandler,Component } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler,ViewController } from 'ionic-angular';
import { MyApp } from './app.component';
import { HttpModule } from '@angular/http';
import { AboutPage } from '../pages/about/about';
import { ContactPage } from '../pages/contact/contact';
import { HomePage } from '../pages/home/home';
import { TabsPage } from '../pages/tabs/tabs';
import { DashboardModule } from '../pages/dashboard/dashboard.module';
import { UpdatepageModule } from '../pages/updatepage/updatepage.module'
import { StatusBar } from '@ionic-native/status-bar';
import { DatePicker } from '@ionic-native/date-picker';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Filetransfer } from '../providers/filetransfer'
import { IonicStorageModule } from  '@ionic/storage';
import {Webservice} from '../providers/webservice'
import {Storagehelper} from '../providers/storagehelper'
import { Transfer, FileUploadOptions, TransferObject } from '@ionic-native/transfer';
import { SocialSharing } from '@ionic-native/social-sharing';
import { File } from '@ionic-native/file'
import { PageSliderModule } from '../pages/page-slider/page-slider.module'
import { PageAudioModule } from '../pages/page-audio/page-audio.module'

import { LocalNotifications } from '@ionic-native/local-notifications';
import { MediaPlugin, MediaObject } from '@ionic-native/media';
import { PageTextModule } from '../pages/page-text/page-text.module'
import { PageVideoModule } from '../pages/page-video/page-video.module'
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { InAppBrowser } from '@ionic-native/in-app-browser';

import { OpenNativeSettings } from '@ionic-native/open-native-settings';
import {NewquestionModule} from '../pages/newquestion/newquestion.module'

import { ThoughtpopupModule } from '../pages/thoughtpopup/thoughtpopup.module'
import {CategorypagesPageModule} from  '../pages/categorypages/categorypages.module'
import {ReminderPageModule} from  '../pages/reminder/reminder.module'
import {NewreminderPageModule} from  '../pages/newreminder/newreminder.module'

import {FavoritepagesPageModule} from '../pages/favoritepages/favoritepages.module'
import {DeletereminderPageModule} from '../pages/deletereminder/deletereminder.module'
@NgModule({
  declarations: [
    MyApp,
    AboutPage,
    ContactPage,
    HomePage,
    TabsPage
  ],
  imports: [
    BrowserModule,
    DashboardModule,
    UpdatepageModule,
    PageTextModule,
    PageSliderModule,
    PageAudioModule,
    PageVideoModule,
    // Addthought,
    ThoughtpopupModule,
    NewquestionModule,
    CategorypagesPageModule,
    ReminderPageModule,
    NewreminderPageModule,
    FavoritepagesPageModule,
    DeletereminderPageModule,
    IonicModule.forRoot(MyApp,{
       activator:'ripple',
       iconMode:"md",
       mode:"md",
       backButtonIcon: 'ios-arrow-back',
       swipeBackEnabled:false
    }, 
{
  links: [
    { loadChildren: '../pages/updatepage/updatepage.module#UpdatepageModule', name: 'Updatepage', segment: 'updatepage', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/page-text/page-text.module#PageTextModule', name: 'PageText', segment: 'page-text', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/page-slider/page-slider.module#PageSliderModule', name: 'PageSlider', segment: 'page-slider', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/page-audio/page-audio.module#PageAudioModule', name: 'PageAudio', segment: 'page-audio', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/dashboard/dashboard.module#DashboardModule', name: 'Dashboard', segment: 'dashboard', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/page-video/page-video.module#PageVideoModule', name: 'PageVideo', segment: 'page-video', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/categorypages/categorypages.module#CategorypagesPageModule', name: 'CategorypagesPage', segment: 'categorypages', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/newreminder/newreminder.module#NewreminderPageModule', name: 'NewreminderPage', segment: 'newreminder', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/deletereminder/deletereminder.module#DeletereminderPageModule', name: 'DeletereminderPage', segment: 'deletereminder', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/reminder/reminder.module#ReminderPageModule', name: 'ReminderPage', segment: 'reminder', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/favoritepages/favoritepages.module#FavoritepagesPageModule', name: 'FavoritepagesPage', segment: 'favoritepages', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/newquestion/newquestion.module#NewquestionModule', name: 'Newquestion', segment: 'newquestion', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/thoughtpopup/thoughtpopup.module#ThoughtpopupModule', name: 'Thoughtpopup', segment: 'thoughtpopup', priority: 'low', defaultHistory: [] }
  ]
}),
    IonicStorageModule.forRoot({
      name: '__Dreamsapp',
         driverOrder: ['indexeddb', 'sqlite', 'websql']
    }) ,
    HttpModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    AboutPage,
    ContactPage,
    HomePage,
    TabsPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    LocalNotifications,
    Webservice,
    SocialSharing,
    Transfer,
    OpenNativeSettings,
    InAppBrowser,
    DatePicker,
    File,
    Filetransfer,
    Storagehelper,
    MediaPlugin,
    ScreenOrientation,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts